import React from 'react';



const PreviewContent = ({
  type,
  content,
  poster,
  title
  }) => {

  if (type === "img") {
    return (
        <React.Fragment>
          <div className="image"
               style={{
                 backgroundImage: `url(${content})`
               }}>
            <img src={content} alt=""/>
          </div>
        </React.Fragment>
    )
  } else if (type === "iframe") {
    return (
        <React.Fragment>
          <div className="iframe">
            <iframe title={title} src={content} />
          </div>
        </React.Fragment>
    )
  } else {
    return (
        <React.Fragment>
          <div className="video-autoplay">
            <video autoPlay muted loop poster={poster}>
              <source src={content}/>
            </video>
          </div>
        </React.Fragment>
    )
  }
}

export default PreviewContent;
